import FontAwesome from "../../../utilities/FontAwesome";
import styles from "./styles/dropdown.module.scss";
import classNames from "classnames";
import NavigationLink from "../NavigationLink";
import TitleWithPopoutIcon from "../TitleWithPopoutIcon";

const groupHeaderClassName = classNames(
  styles.groupHeader,
  "nav-dropdown-item",
  "nav-dropdown-header",
);
const groupLinkClassName = classNames(styles.groupLink, "nav-dropdown-item");
const tileClassName = classNames(styles.tile, "nav-dropdown-item");

interface IDropdownListProps extends NavigationInTree {
  header?: string | false;
  maxHeight?: number;
}

export default function DropdownList(props: IDropdownListProps) {
  const { url, title, description, icon, children } = props;

  if (props.header) {
    return (
      <li
        role={"none"}
        className={styles.group}
        style={{ maxHeight: props.maxHeight }}
      >
        <h2 tabIndex={-1} className={groupHeaderClassName}>
          {icon && <FontAwesome ariaHidden={true} name={icon} />}
          {props.header}
        </h2>
        <ul role={"menu"} aria-label={props.header}>
          {children
            .filter((child) => child.enabled)
            .map((child) => {
              return (
                <li key={child.title + "-" + child.id} role={"none"}>
                  <NavigationLink
                    navigationObj={child}
                    role={"menuitem"}
                    className={groupLinkClassName}
                  >
                    <TitleWithPopoutIcon url={child.url ?? ""}>
                      {child.title}
                    </TitleWithPopoutIcon>
                  </NavigationLink>
                </li>
              );
            })}
        </ul>
      </li>
    );
  } else {
    return (
      <li role={"none"} style={{ maxHeight: props.maxHeight }}>
        <NavigationLink
          navigationObj={props}
          role={"menuitem"}
          className={tileClassName}
        >
          {icon && (
            <span className={styles.tileIcon}>
              <FontAwesome ariaHidden={true} name={icon} />
            </span>
          )}
          <span className={styles.tileText}>
            <TitleWithPopoutIcon url={url ?? ""}>
              <h3>{title}</h3>
            </TitleWithPopoutIcon>
            {description && (
              <span className={styles.tileNote}>{description}</span>
            )}
          </span>
        </NavigationLink>
      </li>
    );
  }
}
